import { ControlledInput } from '@/components/controlled';
import { useFormContext } from 'react-hook-form';
import { Label } from '@/components/ui';
import { TProps } from '..';

const FormContentCreateOrEditCreatorPaymentMethodBankTransfert = ({ fieldNames, readonly = false }: TProps) => {

  const { control } = useFormContext();

  return (
    <div className='space-y-4'>
      <div className='flex flex-col gap-2'>
        <Label>
          IBAN
        </Label>
        <ControlledInput
          maxLength={100}
          disabled={readonly}
          control={control}
          name={fieldNames.paymentInfo.iban}
          placeholder={'IBAN du compte'} />
      </div>
      <div className='flex flex-col gap-2'>
        <Label>
          BIC
        </Label>
        <ControlledInput
          maxLength={20}
          disabled={readonly}
          control={control}
          name={fieldNames.paymentInfo.bic}
          placeholder={'BIC du compte'} />
      </div>
    </div>
  );

};

export default FormContentCreateOrEditCreatorPaymentMethodBankTransfert;
